import type { BlockExportMapping } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { SectionBlock } from "../SectionBlock";
import { BadgeBlock } from "./BadgeBlock";
import { BadgeListBlock } from "./BadgeListBlock";
import { BlockquoteBlock } from "./BlockquoteBlock";
import { ButtonBlock } from "./Button";
import { CodeBlockExport } from "./CodeBlock";
import { ContainerBlock } from "./ContainerBlock";
import { CustomButtonBlock } from "./CustomButtonBlock";
import { CustomHTMLBlock } from "./CustomHTML";
import { EmbedBlock } from "./EmbedBlock";
import { FormBlockExport } from "./FormBlock";
import { GridBlock } from "./GridBlock";
import { ImgBlock } from "./ImgBlock";
import { HorizontalLineBlock } from "./LineBlock";
import { LinkBlock } from "./LinkBlock";
import { PBlock } from "./PBlock";
import { PrimaryButtonBlock } from "./PrimaryButtonBlock";
import { QuoteBlock } from "./Quote";
import { SecondaryButtonBlock } from "./SecondaryButtonBlock";
import { StackBlock } from "./StackBlock";
import { UlBlock } from "./UlListBlock";
import { VideoBlock } from "./VideoBlock";

export const contentBlocks: BlockExportMapping = {
  badge: BadgeBlock,
  badgeList: BadgeListBlock,
  blockquote: BlockquoteBlock,
  button: ButtonBlock,
  code: CodeBlockExport,
  customButton: CustomButtonBlock,
  customHtml: CustomHTMLBlock,
  embed: EmbedBlock,
  primaryButton: PrimaryButtonBlock,
  secondaryButton: SecondaryButtonBlock,
  form: FormBlockExport,
  horizontalLine: HorizontalLineBlock,
  img: ImgBlock,
  link: LinkBlock,
  p: PBlock,
  section: SectionBlock,
  container: ContainerBlock,
  stack: StackBlock,
  grid: GridBlock,
  ul: UlBlock,
  video: VideoBlock,
  quote: QuoteBlock,
};
